import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Textarea from 'components/Textarea/Textarea';
import TextField from 'components/TextField/TextField';

import { DESCRIPTION_LENGTH } from '../../../../../../constants/general';
import CreateSurveyItemPanel from './CreateSurveyItemPanel';

import type { ICreateSurveyPanel } from '../interfaces/ICreateSurveyPanel';

import styles from '../scss/CreateSurvey.module.scss';

function CreateSurveyPanel({ control }: ICreateSurveyPanel) {
  const { t } = useTranslation();

  return (
    <CreateSurveyItemPanel
      title={t('materialityAssessment.createSurvey')}
      description={t('materialityAssessment.createSurveyDescription')}
    >
      <div className={styles.surveyWrapper}>
        <Controller
          control={control}
          name="name"
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <TextField
              name={name}
              value={value}
              label={t('materialityAssessment.surveyName')}
              error={error?.message}
              className={styles.surveyName}
              placeholder={t('materialityAssessment.placeholderName')}
              onChange={(event) => onChange(event.target.value)}
              required
            />
          )}
        />
        <Controller
          control={control}
          name="description"
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <Textarea
              name={name}
              value={value}
              label={t('materialityAssessment.surveyDescription')}
              error={error?.message}
              className={styles.description}
              placeholder={t('materialityAssessment.placeholderDescription')}
              charactersLimit={DESCRIPTION_LENGTH}
              onChange={(e) => onChange(e.target.value.slice(0, DESCRIPTION_LENGTH))}
              required
            />
          )}
        />
      </div>
    </CreateSurveyItemPanel>
  );
}

export default CreateSurveyPanel;
